import DynamicTable from './dynamicTable.component';

export default DynamicTable;